// extracted by mini-css-extract-plugin
export default {"container":"SerieItemInfo_container__7riXv","title":"SerieItemInfo_title__FG1QX"};